import {
  useMyOrdersListApi,
  useOrderApi,
  useOrderUpdateApi,
  useOrderWaybillApi,
} from '@hero/api-hooks';
import { Id } from '@hero/schema';
import { useOrderQueryStore } from '@hero/hooks-shared';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { updateOrder } from '@/services/jobsAPI';

export const useOrder = (orderId: Id) => {
  return useOrderApi(orderId);
};

export const useOrderInTable = (orderId: Id) => {
  const { data, isPending } = useOrder(orderId);
  return { orderData: data, isLoading: isPending };
};

/**
 * Carrier-dashboard "my orders" feed. Backed by the tenant-aware unified
 * endpoint — the server auto-scopes to the current user/org/driver via
 * `Order.tenants[]`, so we no longer branch on `isDriver` to pick a
 * different SDK method.
 */
export const useCarrierOrdersQuery = () => {
  const query = useOrderQueryStore(s => s.filters);
  return useMyOrdersListApi(query);
};

export const useUpdateOrder = (options?: Parameters<typeof useOrderUpdateApi>[0]) => {
  const { t } = useTranslation(['m-order']);
  return useOrderUpdateApi({
    ...options,
    apiFn: updateOrder,
    onSuccess: order => {
      options?.onSuccess?.(order);
      toast.success(t('m-order:toast.success.order_updated'));
    },
    onError: (error: Error) => {
      toast.error(t('m-order:toast.error.order_update', { message: error.message }));
      options?.onError?.(error);
    },
  });
};

export const useCarrierOrderWaybill = (...args: Parameters<typeof useOrderWaybillApi>) => {
  return useOrderWaybillApi(...args);
};
